var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h2',{staticClass:"mb-5 d-flex justify-space-between"},[_c('span',[_vm._v("Novo Produto")])]),_c('form-produto',{attrs:{"produto":_vm.produto},on:{"produto-atualizado":_vm.novoProduto}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }